module.exports = __webpack_public_path__ + "media/images/vertical_barcode-9b3837d03c1119707968eaaa945579ea.png";